module.exports = __webpack_public_path__ + "img/anl1.2aab9e7b.png";